import React from 'react';

const ApplicationSectionTitle = ({ children }) => (
  <p>
    <strong>{children}</strong>
  </p>
);

export default ApplicationSectionTitle;
